<template>
  <nav>
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <v-row>
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'">
        <p :class="mobile() ? 'text-h5 font-weight-bold ml-16 mr-16' : 'text-h5 font-weight-bold'"
          :align="mobile() ? 'center' : 'left'">
          {{ $t('settingsEduAdmin') }}
        </p>
      </v-col>
    </v-row>
    <v-row v-if="!loadingData">
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'">
        <v-form ref="form" @submit.prevent>
          <v-card color="background" elevation="0" max-width="700px">
            <v-card-text>
              <p class="text-body-1 darktext--text no-break mb-2 ml-5">
                {{ $t('labelApiUser') }}
              </p>
              <v-text-field v-model="appId" data-testid="api-user-input" solo class="rounded-xxl text-body-2"
                hide-details="auto" :placeholder="$t('eduAdminApiUserPlaceholder')" :rules="apiUserRules"/>
              <p class="text-body-1 darktext--text no-break mt-4 mb-2 ml-5">
                {{ $t('labelPassword') }}
              </p>
              <v-text-field v-model="token" data-testid="password-input" solo class="rounded-xxl text-body-2"
                hide-details="auto" :placeholder="$t('eduAdminPasswordPlaceholder')" :rules="passwordRules"/>
            </v-card-text>
            <v-card-actions>
              <v-btn ref="test" data-testid="test-button" color="darktext" min-width="100" dark elevation="0" outlined
                class="rounded-xxl text-none px-4" @click="testIntegration()">
                {{ $t('testConnection') }}
              </v-btn>
              <v-btn ref="submit" data-testid="submit-button" type="submit" color="accent" min-width="100" dark
                elevation="0" class="rounded-xxl text-none px-4" @click="integrationId ? updateIntegration() : saveIntegration()">
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages from '../../components/AlertMessages'
import { getIntegrations, saveEduAdminIntegration, updateEduAdminIntegration } from "../../api/spaceApi";
import { ruleRequired } from '../../rules/formRules.js';

export default {
  components: {
    AlertMessages
  },
  mixins: [repeatedMethodsMixin],

  data() {
    return {
      alertMsg: '',
      alertType: '',
      alertValue: false,
      loadingData: false,
      integrationId: null,
      appId: null,
      token: null,
      spaceId: window.$cookies.get("space_id"),
      apiUserRules: ruleRequired('labelApiUser'),
      passwordRules: ruleRequired('labelPassword'),
      valid: true
    }
  },
  computed: {
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {
    this.loadingData = true
    await this.fetchIntegrations()
    this.loadingData = false

  },
  methods: {
    async fetchIntegrations() {
      try {
        const response = await getIntegrations(this.spaceId)
        if (response.status) {
          if (response.status == 200) {
            if (response.data.data.length > 0) {
              this.token = response.data.data.find(item => item.attributes.name == 'eduadmin' ).attributes.token
              this.appId = response.data.data.find(item => item.attributes.name == 'eduadmin' ).attributes.app_id
              this.integrationId = response.data.data.find(item => item.attributes.name == 'eduadmin' ).id
            }
          }
        }
      } catch (e) {
        if (e.response) {
          if (e.response.status == 404) {
            this.$router.push({ name: 'PageNotFound' })
          }
          else if (e.response.status == 403) {
            this.$router.push({ name: 'PageAccessDenied' })
          } else {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    async testIntegration() {
      this.valid = this.$refs.form.validate()
      if(this.valid){ 
        var data = {}
        try {
          if(this.integrationId){
            data = {
              data: {
                type: "eduadmins",
                id: this.integrationId,
                attributes: {
                  app_id: this.appId,
                  token: this.token,
                  name: "eduadmin",
                  test: true
                },
                relationships: {
                  space: {
                    data: {
                      type: "spaces",
                      id: this.spaceId
                    }
                  },
                }
              }
            }
          }else {
            data = {
              data: {
                type: "eduadmins",
                attributes: {
                  app_id: this.appId,
                  token: this.token,
                  name: "eduadmin",
                  test: true
                },
                relationships: {
                  space: {
                    data: {
                      type: "spaces",
                      id: this.spaceId
                    }
                  },
                }
              }
            }
          }
          
          const response = this.integrationId ? await updateEduAdminIntegration(this.integrationId, data) : await saveEduAdminIntegration(data)
          if (response.status == 200) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg = i18n.t('testEduAdminIntegrationSuccess')
          }
        } catch (e) {
          if (e.response) {
            if (e.response.status == 400) {
              for (let i = 0; i < e.response.data.errors.length; i++) {
                if (
                  e.response.data.errors[i].title ==
                  "invalid_grant"
                ) {
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("testEduAdminIntegrationError");
                } else {
                  this.alertValue = true;
                  this.alertType = "error";
                  this.alertMsg = i18n.t("serverError");
                }
              }
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg = i18n.t('serverError')
            }
          }
        }
      }
    },
    
    async saveIntegration() {
      this.valid = this.$refs.form.validate()
      if(this.valid){ 
        try {
          let data = {
            data: {
              type: "eduadmins",
              attributes: {
                app_id: this.appId,
                token: this.token,
                name: "eduadmin",
                test: false,
              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId
                  }
                },
              }
            }
          }
          const response = await saveEduAdminIntegration(data)
          if (response.status == 201) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg = i18n.t('saveEduAdminIntegrationSuccess')
            this.integrationId = response.data.data.id
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    },

    async updateIntegration() {
      this.valid = this.$refs.form.validate()
      if(this.valid){ 
        try {
          let data = {
            data: {
              type: "eduadmins",
              id: this.integrationId,
              attributes: {
                app_id: this.appId,
                token: this.token,
                name: "eduadmin",
                test: false,
              },
              relationships: {
                space: {
                  data: {
                    type: "spaces",
                    id: this.spaceId
                  }
                },
              }
            }
          }
          const response = await updateEduAdminIntegration(this.integrationId, data)
          if (response.status == 200) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg = i18n.t('saveEduAdminIntegrationSuccess')
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg = i18n.t('serverError')
          }
        }
      }
    }
  }
}
</script>
